import { useState } from "react";
import { motion } from "framer-motion";
import { useLang, useT } from "../i18n";
import { GALLERY } from "../data/content";
import { Dialog, DialogContent } from "../components/ui/dialog";

export const Gallery = () => {
  const t = useT();
  const lang = useLang();
  const [active, setActive] = useState(null);

  return (
    <section id="gallery" className="bg-cream-50 py-24 sm:py-36" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="font-mono text-xs uppercase tracking-[0.35em] text-bergamote-600 mb-5"
        >
          {t.ch3_label}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="font-serif font-medium tracking-tight text-3xl sm:text-4xl lg:text-5xl text-bergamote-900"
          data-testid="gallery-title"
        >
          {t.ch3_title}
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mt-4 text-bergamote-800/80 max-w-xl"
        >
          {t.ch3_sub}
        </motion.p>

        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 auto-rows-[180px] sm:auto-rows-[220px] gap-4 sm:gap-5">
          {GALLERY.map((img, i) => (
            <motion.button
              key={img.src}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              onClick={() => setActive(img)}
              data-testid={`gallery-item-${i}`}
              className={`overflow-hidden border border-bergamote-600/15 group relative ${img.cls}`}
            >
              <img
                src={img.src}
                alt={img.alt[lang]}
                loading="lazy"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <span className="absolute inset-0 bg-bergamote-900/0 group-hover:bg-bergamote-900/20 transition-colors duration-500" />
            </motion.button>
          ))}
        </div>
      </div>

      <Dialog open={!!active} onOpenChange={() => setActive(null)}>
        <DialogContent className="max-w-3xl bg-cream-50 border-bergamote-600/20 p-2" data-testid="gallery-lightbox">
          {active && (
            <img src={active.src} alt={active.alt[lang]} className="w-full max-h-[75vh] object-cover rounded-xl" />
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};
